import RoleFormModule from './containers/roleFormModule'

export {default as RoleFormModuleLayout} from './components/roleFormModuleLayout'

export default RoleFormModule
